export default __webpack_public_path__ + "static/media/ic-paso-tres.02c47421.svg";